import React from "react";

export const CopyIcon = ({...props}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.125 16H5.625C4.59102 16 3.75 15.159 3.75 14.125V5.625C3.75 4.59102 4.59102 3.75 5.625 3.75H14.125C15.159 3.75 16 4.59102 16 5.625V14.125C16 15.159 15.159 16 14.125 16ZM5.625 5C5.28037 5 5 5.28037 5 5.625V14.125C5 14.4696 5.28037 14.75 5.625 14.75H14.125C14.4696 14.75 14.75 14.4696 14.75 14.125V5.625C14.75 5.28037 14.4696 5 14.125 5H5.625ZM2.5 11H1.875C1.53037 11 1.25 10.7196 1.25 10.375V1.875C1.25 1.53037 1.53037 1.25 1.875 1.25H10.375C10.7196 1.25 11 1.53037 11 1.875V2.46875H12.25V1.875C12.25 0.841016 11.409 0 10.375 0H1.875C0.841016 0 0 0.841016 0 1.875V10.375C0 11.409 0.841016 12.25 1.875 12.25H2.5V11Z"
        fill="#2079CB"
      />
    </svg>
  );
};
